// src/utils/buildUrl.ts
function buildUrl(url, baseUrl, searchParams) {
  const fetchUrl = typeof baseUrl === "string" && baseUrl !== "" ? new URL(url, baseUrl).toString() : url;
  const searchParamsStr = new URLSearchParams(searchParams).toString();
  return `${fetchUrl}${searchParamsStr !== void 0 && searchParamsStr !== "" ? `?${searchParamsStr}` : ""}`;
}
export {
  buildUrl as default
};
